<template>
  <div class="d-flex align-center" @click="ordenar">
    <slot>
      {{ header.text }}
    </slot>

    <template v-if="ORDENACAO_ATUAL_COLUNA">
      <v-icon v-if="ORDENACAO_ATUAL_COLUNA.order === 'up'" small v-text="'mdi-arrow-up'" />
      <v-icon v-else-if="ORDENACAO_ATUAL_COLUNA.order === 'down'" small v-text="'mdi-arrow-down'" />
    </template>
  </div>
</template>

<script>
export default {
  name: "HeaderCurvaAbc",
  props: {
    header: Object
  },
  computed: {
    ORDENACAO_ATUAL_COLUNA() {
      const colunas = this.$store.getters["tabela_compra/getColunasEmOrdenacaoCombinada"];
      return colunas.find(col => col.value === this.header.value)
    }
  },
  methods: {
    ordenar() {
      const ev = {
        value: this.header.value,
        order: null,
        header: this.header,
      };

      if (!this.ORDENACAO_ATUAL_COLUNA) {
        ev.order = 'up';
      } else if (this.ORDENACAO_ATUAL_COLUNA.order === 'up') {
        ev.order = 'down';
      }

      this.$emit('ordenar', ev);
    }
  }
}
</script>

<style scoped>

</style>
